import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CandTestScheduleComponent } from '../reports/cand-test-schedule/cand-test-schedule.component';
import { ExamStatusComponent } from '../reports/exam-status/exam-status.component';
import { QuesAnalysisComponent } from '../reports/ques-analysis/ques-analysis.component';
import { CandResLogComponent } from '../reports/cand-res-log/cand-res-log.component';
import { CandExamResComponent } from '../reports/cand-exam-res/cand-exam-res.component';
import { PrintScoreCardComponent } from '../reports/print-score-card/print-score-card.component';
import { ScoreComponent } from '../reports/score/score.component';
import { PerceWiseScoreComponent } from '../reports/perce-wise-score/perce-wise-score.component';
import { TopicWiseScoreComponent } from '../reports/topic-wise-score/topic-wise-score.component';
import { ViewQuesPaperComponent } from '../reports/view-ques-paper/view-ques-paper.component';
import { BulkDownloadComponent } from '../reports/view-ques-paper/bulk-download/bulk-download.component';
import { MarksheetComponent } from '../reports/marksheet/marksheet.component';
import { EventBasedLogComponent } from '../reports/event-based-log/event-based-log.component';
import { DayEndComponent } from '../reports/day-end/day-end.component';
import { ExamDurationComponent } from '../reports/exam-duration/exam-duration.component';
import { AnswerSheetComponent } from '../reports/answer-sheet/answer-sheet.component';
import { IdleCandidateComponent } from '../reports/idle-candidate/idle-candidate.component';
import { ReportsComponent } from '../reports/reports/reports.component';
import { FullLayoutComponent } from "../containers/full-layout/full-layout.component";
import { BulkGenerationComponent } from '../reports/bulk-generation/bulk-generation.component';
import { BulkAuditTrailComponent } from '../reports/bulk-generation/bulk-audit-trail/bulk-audit-trail.component';
import { BulkCandResLogComponent } from '../reports/bulk-generation/bulk-cand-res-log/bulk-cand-res-log.component';


import { AuthguardService } from "../shared";
import { CandSeatsComponent } from './cand-seats/cand-seats.component';
import { DeviceListComponent } from './device-list/device-list.component';


const routes: Routes = [
    {
        path: "",
        data: {
            title: ""
        },
        canActivate: [AuthguardService],
        component: FullLayoutComponent,
        children: [
            {
                path: "",
                data: {
                    title: "Reports"
                },
                component: ReportsComponent
            },
            {
                path: 'cand-test-schedule',
                component: CandTestScheduleComponent,
                data: {
                    title: 'Candidate Test Schedule'
                }
            },
            {
                path: 'exam-status',
                component: ExamStatusComponent,
                data: {
                    title: 'Exam Status'
                }
            },
            {
                path: 'ques-analysis',
                component: QuesAnalysisComponent,
                data: {
                    title: 'Question Analysis'
                }
            },
            {
                path: 'cand-res-log',
                component: CandResLogComponent,
                data: {
                    title: 'Candidate Response Log Report'
                }
            },
            {
                path: 'cand-exam-res',
                component: CandExamResComponent,
              
            },
            {
                path: 'cand-exam-res/:center/:batch/:candidate',
                component: CandExamResComponent,
                
            },
            {
                path: 'cand-exam-res/:center/:batch/:candidate/logs',
                component: CandResLogComponent,
                
            },
            {
                path: 'print-score-card',
                component: PrintScoreCardComponent,
                data: {
                    title: 'Print Score Card'
                }
            },
            {
                path: 'score',
                component: ScoreComponent,
                data: {
                    title: 'Score Report'
                }
            },
            {
                path: 'perce-wise-score',
                component: PerceWiseScoreComponent,
                data: {
                    title: ' Score Report Percentage Wise'
                }
            },
            {
                path: 'topic-wise-score',
                component: TopicWiseScoreComponent,
                data: {
                    title: 'Topic wise Score Report'
                }
            },
            {
                path: 'cand-exam-res/:center/:batch/:candidate/questions',
                component: ViewQuesPaperComponent,
                 
            },
            {
                path: 'cand-exam-res/:center/:batch/:candidate/seats',
                component: CandSeatsComponent,
               
            },
            {
                path: 'bulk-download',
                component: BulkDownloadComponent,
                data: {
                    title: 'Bulk Download'
                }
            },
            {
                path: 'marksheet',
                component: MarksheetComponent,
                data: {
                    title: 'Marksheet Report'
                }
            },
            {
                path: 'event-based-log ',
                component: EventBasedLogComponent,
                data: {
                    title: 'Event Based Log Report'
                }
            },
            {
                path: 'day-end',
                component: DayEndComponent,
                data: {
                    title: 'Day End Report'
                }
            },
            {
                path: 'exam-duration',
                component: ExamDurationComponent,
                data: {
                    title: 'Exam-Duration-Report'
                }
            },
            {
                path: 'answer-sheet',
                component: AnswerSheetComponent,
                data: {
                    title: 'Answer Sheet Report'
                }
            },
            {
                path: 'idle-candidate',
                component: IdleCandidateComponent,
                data: {
                    title: 'Idle Candidate'
                }
            },
            {
                path: 'bulk-generation',
                component: BulkGenerationComponent,
                data: {
                    title: 'Bulk Generation'
                }
            },
            {
                path: 'bulk-audit-trail',
                component: BulkAuditTrailComponent,
                data: {
                    title: 'Bulk Audit Trail'
                }
            },
            {
                path: 'bulk-cand-res-log',
                component: BulkCandResLogComponent,
                data: {
                    title: 'Bulk Candidate Response Log'
                }
            },
            {
                path: 'devices',
                component: DeviceListComponent,
                data: {
                    title: 'Devices'
                }
            },



        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ReportsRouteModule { }
